module.exports = __webpack_public_path__ + "static/image0001-b4d3df5334116a586544b109895d2327.jpg";